export default class Constants {
	static BASE_URL = document.querySelector('base')?.href || '/';
}
